import { GrowthBook } from "@growthbook/growthbook-react";
import { getTracking, setTracking } from "@website/store/tracking";
import { isChannel } from "@website/utils/channel/helpers";
import { isSSR } from "@website/utils/is-ssr";
import keyBy from "lodash-es/keyBy";
import mapValues from "lodash-es/mapValues";

let growthbook: GrowthBook;

export const GenerateGrowthBookInstance = () => {
  if (isSSR()) return;
  growthbook = new GrowthBook({
    enabled: isChannel(["web", "website", "jek"]),
    apiHost: process.env.NEXT_PUBLIC_BASE_URL_GPI,
    clientKey: "sdk-Z2itvy5yPKT5xu",
    enableDevMode: false,
    subscribeToChanges: true
    // trackingCallback: (experiment, result) => {
    //   // TODO: Use your real analytics tracking system
    //   // console.log("Viewed Experiment", {
    //   //   experimentId: experiment.key,
    //   //   variationId: result.key
    //   // });
    // }
  });

  growthbook
    .init({ streaming: true })
    // eslint-disable-next-line unicorn/prefer-top-level-await
    .finally(() => {
      setTracking((previous) => ({
        ...previous,
        experiment: {
          experiment_new_tour_design: isChannel(["telesale"])
            ? "true"
            : Math.random() < 0.5
              ? "true"
              : "false",
          experiment_nearby_cities_toggle:
            isChannel(["jek", "website", "android", "snapp-ir"]) &&
            Math.random() < 0.8
              ? "true"
              : "false",
          ...previous.experiment,
          ...getAllExperiments()
        }
      }));
    });

  growthbook.setAttributes({
    id: getTracking().aid
  });
};

const getAllExperiments = () =>
  mapValues(
    keyBy([...(growthbook?.getAllResults().values() ?? [])], "experiment.key"),
    "result.inExperiment"
  );
